import React, { Component } from 'react';
import {
  Flex, FormControl, Input, Select, IconButton
} from '@chakra-ui/react';
import { MdCheck, MdClose } from 'react-icons/md';
import { User } from '../../store/user/types';

interface UserNameFormProps {
  user: User
  onSubmit: (updatedUser: User) => void;
  onClose: () => void;
}

class UserNameForm extends Component<UserNameFormProps> {

  state = {
    firstName: this.props.user.firstName,
    lastName: this.props.user.lastName,
  }

  render() {
    const canSubmit = this.state.firstName.length > 2 && this.state.firstName.length < 32;
    const { user, onSubmit, onClose } = this.props;
    return (
        <Flex direction={'row'} align={'middle'}>
        <FormControl flex={5}>
          <Input 
            placeholder={'First Name'}
            onChange={(e) => this.setState({firstName: e.target.value})}
            value={this.state.firstName} 
            style={{ borderRadius: 25}}
          />
        </FormControl>
        <FormControl flex={5}>
          <Input 
            placeholder={'Last Name'}
            onChange={(e) => this.setState({lastName: e.target.value})}
            value={this.state.lastName} 
            style={{ borderRadius: 25}}
          />
        </FormControl>
        <IconButton 
          onClick={() => {
            if (canSubmit) {
              onSubmit({
                ...user,
                ...this.state
              })
              onClose()
            }
          }}
          aria-label='Submit' 
          colorScheme={canSubmit ? 'green' : undefined}
          borderRadius={25} 
          ml={1} 
        >
          <MdCheck />
        </IconButton>
        <IconButton 
          onClick={() => onClose()}
          aria-label='Close' 
          borderRadius={25} 
          ml={1} 
        >
          <MdClose />
        </IconButton>
        </Flex>       
    )
  }
}

  export default UserNameForm;